import "../Portfolio/Portfolio.css";

const Portfolio = () => {
    return (
        <>
            <div className="container">
                <div className="row d-flex">
                    <div className="col-12 col-md-8 d-flex flex-column">
                        <div className="row">
                            {/* Card 1 */}
                            <div className="col-12 col-md-6 mb-4">
                                <div className="card d">
                                    <img
                                        src="/images/6.png"
                                        className="card-img-top zoom-tilt equal-size-img"
                                        alt="Card image 1"
                                    />
                                </div>
                            </div>

                            {/* Card 2 */}
                            <div className="col-12 col-md-6 mb-4">
                                <div className="card">
                                    <img
                                        src="/images/6.png"
                                        className="card-img-top zoom-tilt equal-size-img"
                                        alt="Card image 2"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right column with carousel */}
                    <div className="col-12 col-md-4 d-flex flex-column">
                        <div
                            id="carouselExampleIndicators"
                            className="carousel slide"
                            data-ride="carousel"
                        >
                            <ol className="carousel-indicators">
                                <li
                                    data-target="#carouselExampleIndicators"
                                    data-slide-to="0"
                                    className="active"
                                ></li>
                                <li
                                    data-target="#carouselExampleIndicators"
                                    data-slide-to="1"
                                ></li>
                                <li
                                    data-target="#carouselExampleIndicators"
                                    data-slide-to="2"
                                ></li>
                            </ol>
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img
                                        className="d-block w-100 equal-size-img"
                                        src="/images/8.png"
                                        alt="First slide"
                                    />
                                </div>
                                <div className="carousel-item">
                                    <img
                                        className="d-block w-100 equal-size-img"
                                        src="/images/8.png"
                                        alt="Second slide"
                                    />
                                </div>
                                <div className="carousel-item">
                                    <img
                                        className="d-block w-100 equal-size-img"
                                        src="/images/8.png"
                                        alt="Third slide"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*--------second Container---------------------- */}
            <div className="container">
                <div className="row">
                    <div className="col-xl-3"></div>
                    <div className="col-xl-6">
                        <div className="card">
                            <img
                                src="/images/11.jpg"
                                className="hover-effect-image"
                                alt="Card image 2"
                            />
                        </div>
                    </div>
                    <div className="col-xl-3"></div>
                </div>
            </div>
        </>
    );
};

export default Portfolio;